import * as React from "react";
import Breadcrumbs from "../core/Breadcrumbs";
import CommissionCalculatorForm from "./CommissionCalculatorForm";
import ModernCard from "../core/ModernCard";
import { getCommissionConfigs } from "../../libs/commission_calculator";
import Loader from "../core/Loader";
import { Link } from "react-router-dom";
import Button from "../core/Button";
import usePromise from "../hooks/usePromise";
import { useState } from "react";
import Select from "react-select";
import Panel from "../core/Panel";
import CommissionConfigViewModal from "./CommissionConfigViewModal";

interface IProps {
  user: IUser;
}

export default function CommissionTester({ user }: IProps) {
  const [viewingConfig, setViewingConfig] = useState(false);

  const [configs, { loading: loadingConfigs }] = usePromise(() =>
    getCommissionConfigs(user.organization.id).then(cfgs =>
      cfgs.filter(c => !c.archived)
    )
  );

  const [selectedConfigId, setSelectedConfigId] = useState(
    user.commissionConfig ? user.commissionConfig.id : null
  );

  const config =
    configs && selectedConfigId
      ? configs.find(c => c.id === selectedConfigId)
      : null;

  let cardContent: React.ReactNode = <Loader />;
  const configsDropdown = (
    <>
      <label>Selected Configuration</label>
      <div className={"columns is-vcentered"}>
        <div className="column">
          <Select
            options={
              configs ? configs.map(c => ({ label: c.name, value: c.id })) : []
            }
            onChange={(opt: ISelectOption) => setSelectedConfigId(opt.value)}
            value={config ? { label: config.name, value: config.id } : null}
            clearable={false}
          />
        </div>
        {config && (
          <div className="column is-narrow">
            <Button onClick={() => setViewingConfig(true)} color={"info"}>
              <i className="fa fa-eye" /> View
            </Button>
          </div>
        )}
      </div>
    </>
  );

  if (!loadingConfigs && config) {
    cardContent = (
      <>
        {configsDropdown}
        <hr />
        <CommissionCalculatorForm config={config} allowReset={true} />
      </>
    );
  } else if (!loadingConfigs && !config) {
    cardContent = (
      <>
        <Panel heading={"No Assigned Configuration"} type={"warning"}>
          You do not have a default commission configuration assigned to you. To
          continue, please choose one to test from the menu below.
        </Panel>
        {configsDropdown}
      </>
    );
  }

  return (
    <>
      <Breadcrumbs
        crumbs={[
          {
            label: "Commission Calculator",
            routerLink: true,
            route: "/",
          },
          { label: "Tester" },
        ]}
      />
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <Link to={`/`} className={"btn btn-default"}>
              <i className="fa fa-arrow-left" /> Back
            </Link>
          </div>
        </div>
      </div>
      <ModernCard title={"Commission Tester"} ta="left" m="0px">
        <p>
          Use this page to test out quota numbers, nothing here will be saved.
        </p>
        <hr />
        {cardContent}
      </ModernCard>
      {config && (
        <CommissionConfigViewModal
          open={viewingConfig}
          close={() => setViewingConfig(false)}
          config={config}
        />
      )}
    </>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionTester.tsx